import { useEffect, useState } from "react";
import ManualRow from "./ManualRow";
import MultipleRows from "./MultipleRows";
import SingleRow from "./SingleRow";

export default function SelectExcelData({
  columnLabels,
  spreadsheetData,
  setLabelData,
  rowsData,
  setRowsData,
}) {
  /*   All States
   ********************************************* */

  let noOfRows = 6;
  const [rowData, setRowData] = useState(
    Array.from({ length: noOfRows }, (_, i) => ({
      rowNo: i + 1,
      rowType: "manual",
      rowValues: {},
    }))
  );

  const [startRange, setStartRange] = useState(1);
  const [endRange, setEndRange] = useState(1);

  /*   All Functions
   ********************************************* */

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    setRowData(
      rowsData
        ? rowsData
        : Array.from({ length: noOfRows }, (_, i) => ({
            rowNo: i + 1,
            rowType: "manual",
            rowValues: {},
          }))
    );

    setStartRange((prev) => 1);
    setEndRange((prev) => spreadsheetData?.length);
  }, [spreadsheetData, rowsData]);

  return (
    <div className="px-2 py-1">
      <div className="d-flex justify-content-between align-items-center mb-1">
        <h4 className="h4 mb-0">Select Label Data</h4>
        {spreadsheetData?.length ? (
          <h5 className="d-flex mb-0 align-items-center text-nowrap">
            From
            <input
              type="number"
              min={1}
              style={{ display: "inline-block" }}
              value={startRange}
              onChange={(e) => {
                let newRange = parseInt(e.target.value);
                if (newRange > spreadsheetData?.length) {
                  newRange = spreadsheetData?.length;
                }
                if (newRange > endRange) {
                  newRange = endRange;
                }
                setStartRange((prev) => newRange);
              }}
              max={spreadsheetData?.length}
              className="form-control form-control-sm mx-1"
            />
            to
            <input
              type="number"
              min={0}
              style={{ display: "inline-block" }}
              value={endRange}
              onChange={(e) => {
                let newRange = parseInt(e.target.value);
                if (newRange > spreadsheetData?.length) {
                  newRange = spreadsheetData?.length;
                }
                setEndRange((prev) => newRange);
              }}
              max={spreadsheetData?.length}
              className="form-control form-control-sm mx-1"
            />
            ( Total: {spreadsheetData?.length})
          </h5>
        ) : (
          ""
        )}
        <div>
          <button
            onClick={() => {
              let _labelData = spreadsheetData.length
                ? spreadsheetData?.slice(startRange - 1, endRange)
                : [rowData];

              setLabelData((prev) => _labelData);

              setRowsData((prev) => rowData);
            }}
            className="btn btn-info btn-sm"
          >
            Load Data
          </button>
        </div>
      </div>
      <hr className="mt-0" />
      <div>
        {rowData?.map((row, index) => {
          return (
            <div className="row mb-1" key={index}>
              <div className="col-md-2">
                <select
                  onChange={(e) => {
                    const newRowData = [...rowData];
                    newRowData[index].rowType = e.target.value;
                    setRowData((prev) => newRowData);
                  }}
                  value={row.rowType || ""}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  className=" form-control form-control-sm"
                  name="rowType"
                >
                  <option value="manual">Manual</option>
                  <option value="single">Single</option>
                  <option value="multiple">Multiple</option>
                  <div className=""></div>
                </select>
              </div>
              <div className="col-md-10">
                {row.rowType === "manual" && (
                  <ManualRow
                    selectedRow={row}
                    rowData={rowData}
                    rowIndex={index}
                    updateFunc={setRowData}
                  />
                )}
                {row.rowType === "single" && (
                  <SingleRow
                    columnLabels={columnLabels}
                    selectedRow={row}
                    rowData={rowData}
                    rowIndex={index}
                    updateFunc={setRowData}
                  />
                )}
                {row.rowType === "multiple" && (
                  <MultipleRows
                    columnLabels={columnLabels}
                    selectedRow={row}
                    rowData={rowData}
                    rowIndex={index}
                    updateFunc={setRowData}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
